import { render, staticRenderFns } from "./Rating5StarsElement.vue?vue&type=template&id=61ece683&"
import script from "./Rating5StarsElement.vue?vue&type=script&lang=ts&"
export * from "./Rating5StarsElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports